import { render, staticRenderFns } from "./re_radioset.vue?vue&type=template&id=76baa07b&scoped=true"
import script from "./re_radioset.vue?vue&type=script&lang=js"
export * from "./re_radioset.vue?vue&type=script&lang=js"
import style0 from "./re_radioset.vue?vue&type=style&index=0&id=76baa07b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76baa07b",
  null
  
)

export default component.exports